import { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { ContentContainer } from '../../../components/custom_components/ContentContainer'
import { LoadingAndErrors } from '../../../components/custom_components/LoadingAndErrors'
import '../index.less'
import { PerInfoBox } from '../../../components/custom_components/InfoBox'
import { InfoBoxTile } from '../../../components/custom_components/InfoBox/InfoBoxTileTemplate/InfoBoxTile'
import PerText from '../../../components/custom_components/Text'
import { HRSettingsHeader } from './HRSettingsHeader'
import { HRSettingsContent } from './HRSettingsContent'
import { useHRSettingsStore } from './HRSettingsStore'
import { useCollapse } from '../../../routes/collapse-context'
import { useAuth } from '../../../context/auth-context'
import useCompaniesOfResponsible from '../../../graphql/company/hooks/useCompaniesOfResponsible'

export const HRSettingsView: FC = () => {
  const { t } = useTranslation()
  const { user } = useAuth()
  const collapsed = useCollapse()
  const [initStore, storeInitialized] = useHRSettingsStore((state) => [state.initStore, state.storeInitialized])

  const { data, error, loading } = useCompaniesOfResponsible()

  useEffect(() => {
    if (!!data && !!data.findCompaniesAndCountriesByResponsible && !!data.findCompaniesAndCountriesByResponsible.length) {
      initStore(data.findCompaniesAndCountriesByResponsible)
    }
  }, [data, initStore])

  const isHrAdmin = () => {
    if (!user || !user.roles || user.roles.length === 0) {
      return false
    }
    for (const role of user.roles) {
      if (role.includes('ADMIN')) {
        return true
      }
    }
    return false
  }

  if (
    !user.roles ||
    user.roles.length === 0 ||
    !isHrAdmin() ||
    loading ||
    error ||
    !data ||
    !data.findCompaniesAndCountriesByResponsible ||
    (!!data.findCompaniesAndCountriesByResponsible.length && !storeInitialized)
  ) {
    return (
      <ContentContainer collapsed={collapsed}>
        <LoadingAndErrors
          isLoading={loading}
          hasNoData={!data || !data.findCompaniesAndCountriesByResponsible}
          error={error}
          isPermissionDenied={!error && (!user.roles || user.roles.length === 0 || !isHrAdmin())}
          showSpinner
        />
      </ContentContainer>
    )
  } else if (!!data && !data.findCompaniesAndCountriesByResponsible.length) {
    return (
      <PerInfoBox>
        <InfoBoxTile
          heading={t('hrSettings.empty.heading')}
          headingAlign="center"
          contentAlign="center"
          headingColor="secondary"
          headingMt="xl"
        >
          <PerText>{t('hrSettings.empty.message')}</PerText>
        </InfoBoxTile>
      </PerInfoBox>
    )
  }

  return (
    <ContentContainer collapsed={collapsed}>
      <HRSettingsHeader />
      <HRSettingsContent />
    </ContentContainer>
  )
}
